import { Children, ReactNode, useEffect, useRef, useState } from "react";
import Swiper from "swiper";
import { register } from 'swiper/element/bundle';
import { SwiperProps } from "swiper/react";

register();

const InteriorsHero = ({ children }: { children: ReactNode }) => {
    const childrens = Children.toArray(children);
    const swiperRef = useRef() as any;
    const [realIndex, setRealIndex] = useState(1);

    useEffect(() => {
        const swiperContainer = swiperRef.current;

        if (!swiperContainer) return;

        const params: SwiperProps = {
            effect: 'fade',
            speed: 750,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            on: {
                realIndexChange: (swiper: Swiper) => {
                    setRealIndex(swiper.realIndex + 1);
                },
            },
        };

        Object.assign(swiperContainer, params);
        swiperContainer.initialize();
    }, [swiperRef])

    const slideTo = (index: number) => {
        const swiperContainer = swiperRef.current;
        if (swiperContainer?.swiper) {
            swiperContainer.swiper.slideTo(index);
        }
    };

    const activeButtonClasses = (expectedSlide: number): string => {
        if (realIndex === expectedSlide) {
            return 'text-[#FFF] bg-[#0057A2]';
        }

        return 'text-[#333] bg-[#D9D9D9]'
    }

    return (
        <section className="px-4 relative w-full md:h-[800px] h-[600px] mt-2 md:mb-[66px] mb-[190px]">
            <swiper-container ref={swiperRef} init={false} style={{ height: '100%' }}>
                {childrens.length > 0 && childrens.map((child, i) => (
                    <swiper-slide key={i}>
                        {child}
                        <div className="md:flex hidden flex-wrap gap-y-4 items-center justify-center gap-x-4 mb-5 md:-mt-20 -mt-[150px] relative">
                            <button onClick={() => slideTo(1)} className={`transition-all ease-in-out duration-200 text-[20px] px-[48px] py-[13px] inline-block ${activeButtonClasses(2)}`}>
                                Inwestor
                            </button>
                            <button onClick={() => slideTo(0)} className={`transition-all ease-in-out duration-200 text-[20px] font-bold px-[48px] py-[13px] inline-block ${activeButtonClasses(1)}`}>
                                Klient indywidualny
                            </button>
                        </div>
                    </swiper-slide>
                ))}

            </swiper-container>
            <div className="flex md:hidden flex-wrap gap-y-4 items-center justify-center gap-x-4 mb-5 relative">
                <button onClick={() => slideTo(1)} className={`transition-all ease-in-out duration-200 text-[20px] px-[48px] py-[13px] inline-block md:max-w-fit max-w-full w-full ${activeButtonClasses(2)}`}>
                    Inwestor
                </button>
                <button onClick={() => slideTo(0)} className={`transition-all ease-in-out duration-200 text-[20px] font-bold px-[48px] py-[13px] inline-block md:max-w-fit max-w-full w-full ${activeButtonClasses(1)}`}>
                    Klient indywidualny
                </button>
            </div>
        </section>
    )
}

export default InteriorsHero;